import { render, staticRenderFns } from "./pageTishengjianyi.vue?vue&type=template&id=65f090d7&scoped=true"
import script from "./pageTishengjianyi.vue?vue&type=script&lang=js"
export * from "./pageTishengjianyi.vue?vue&type=script&lang=js"
import style0 from "./pageTishengjianyi.vue?vue&type=style&index=0&id=65f090d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f090d7",
  null
  
)

export default component.exports